import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import Categories from 'ContentUtils/constants/Categories';
import ContentRoutes from 'ContentUtils/Routes';

// @ts-ignore Untyped module
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import { Flex } from 'foundations-components/components/Flex';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getContentDashboardLinkTextKey = categoryId => {
  switch (categoryId) {
    case Categories.blog_post.id:
      return 'contentManagementPanel.blogPostsDashboardLink';
    case Categories.blog_listing_page.id:
      return 'contentManagementPanel.blpDashboardLink';
    default:
      return 'contentManagementPanel.pagesDashboardLink';
  }
};
const ContentManagementSidebarHeader = ({
  contentTypeId
}) => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingBlock: "500",
      paddingInlineEnd: "1100",
      paddingInlineStart: "250",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      borderBlockEndColor: "border-core-subtle",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.header"
        })
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: ContentRoutes.dashboard(contentTypeId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getContentDashboardLinkTextKey(contentTypeId)
        })
      })]
    }), /*#__PURE__*/_jsx(CloseButton, {
      color: "icon-core-subtle",
      size: "medium",
      onClick: () => dispatch(closePatagoniaSidebar())
    })]
  });
};
export default ContentManagementSidebarHeader;